import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Form, Icon, Input, Col, Row, Avatar, Card, Divider, Radio, Upload, message } from 'antd';
import SignatureCanvas from 'react-signature-canvas';
import "./sigCanvas.css";

const { TextArea } = Input;

const ZohoForm = (props) => {
    const [signature, setImageURL] = useState(null);
    const [toggle, setSteps] = useState(true);
    const sigCanvas1 = useRef({})
    const sigCanvas2 = useRef({})
    const clear1 = () => {
        sigCanvas1.current.clear()
    }
    const clear2 = () => {
        sigCanvas2.current.clear()
    }
    const save = () => {
        setImageURL(sigCanvas1.current.getTrimmedCanvas().toDataURL("image/png"));

    }
    const columns = [
        {
            title: 'SO No / Part Req ID',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Part Number',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Part Description',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Removed Part CT #',
            dataIndex: 'name2',
            key: 'name2',
        },
        {
            title: 'Installed Part CT#',
            dataIndex: 'age2',
            key: 'age2',
        },
        {
            title: 'Status (Def/DOA/Good)',
            dataIndex: 'address2',
            key: 'address2',
        },
    ];

    const validatorSignature = (rule, value, callback) => {
        console.log(value, 'initials', sigCanvas1.current.isEmpty())
        if (sigCanvas1.current.isEmpty()) {

            callback("please fill this field!");
            return;
            // }
            // callback('Project Name initials already in use!');
            // })
        } else {
            callback()
        }

    }
    const onDateChange = (value, dateString) => {
        console.log(value, dateString, 'dateeeeeeeeeee')
        // this.setState({
        //    dateTimeString: dateString,
        //    dateValue:value,
        // })
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log(sigCanvas1.current.getTrimmedCanvas().toDataURL("image/png"), 'img',)
                console.log(values, 'values.......')
            }
        });
    }

    const clickNext = () => {
        setSteps(false)
    }

    const handleBack = () => {
        setSteps(true)
    }

    const { getFieldDecorator } = props.form;
    const formItemLayout = {
        labelCol: { xs: 24, sm: 8 },
        wrapperCol: { xs: 24, sm: 16 },
    };

    const { Dragger } = Upload;

    const file_props = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
    };


    return (
        <Card className='gx-card' title="" style={{ width: "100%", height: "100%", overflow: "auto" }}>
            <Row>
            <Col lg={24} md={24} sm={24} xs={24}  >
                <p> After Submitting the Form Download the response as PDF and Upload it</p>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}  >

                    <iframe frameBorder="0" style={{ height: 700, width: "100%", border: "none" }} src='https://forms.zohopublic.in/classyserve/form/TestForm/formperma/joz4geu3HNLNVnxEDtMSHoXWbtjRq3vHPOzW5_9SpfY'></iframe>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}   >
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon">
                            <Icon type="inbox" />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">
                            Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                            band files
                        </p>
                    </Dragger>
                </Col>
            </Row>
        </Card>
    )
}

export default Form.create()(ZohoForm);